import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import type { SelectChangeEvent } from '@mui/material/Select';
import type { GuardianRelationship } from '@/types/parental-consent';
import {
  guardianRelationshipOptions,
  parentalConsentCopy,
} from '@/Pages/ParentalConsent/copy';
import '@/Pages/ParentalConsent/ParentalConsentPage.sass';

type RelationshipSelectProps = {
  value: GuardianRelationship | '';
  error?: string;
  showError: boolean;
  onChange: (value: GuardianRelationship) => void;
  onBlur: () => void;
};

export function RelationshipSelect({
  value,
  error,
  showError,
  onChange,
  onBlur,
}: RelationshipSelectProps): JSX.Element {
  const hasError = showError && Boolean(error);
  const errorId = 'guardianRelationship-error';

  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value as GuardianRelationship);
  };

  return (
    <FormControl
      fullWidth
      margin="normal"
      error={hasError}
      className="guardian-form__relationship"
      data-testid="guardian-field-guardianRelationship"
    >
      <InputLabel id="guardianRelationship-label">
        {parentalConsentCopy.guardianRelationshipLabel}
      </InputLabel>
      <Select
        labelId="guardianRelationship-label"
        id="guardianRelationship"
        name="guardianRelationship"
        value={value}
        label={parentalConsentCopy.guardianRelationshipLabel}
        onChange={handleChange}
        onBlur={onBlur}
        displayEmpty
        inputProps={{
          'aria-invalid': hasError,
          'aria-describedby': hasError ? errorId : undefined,
        }}
      >
        <MenuItem value="" disabled>
          {parentalConsentCopy.guardianRelationshipPlaceholder}
        </MenuItem>
        {guardianRelationshipOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {hasError ? (
        <FormHelperText id={errorId} role="alert">
          {error}
        </FormHelperText>
      ) : null}
    </FormControl>
  );
}
